import { render, staticRenderFns } from "./ApproverCard.vue?vue&type=template&id=5d465efa"
import script from "./ApproverCard.vue?vue&type=script&lang=js"
export * from "./ApproverCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports